import { UploadPage } from 'src/views/tmp-admin/master-upload'
import pathMap from 'src/paths/PathMap_TmpAdmin'

export default class TmpMassUploadRoute {
    getConfigurations() {
        return [

            {
                exact: true,
                path: pathMap.MASTER_UPLOAD,
                component: UploadPage
            }
        ]
    }
}
